export default __webpack_public_path__ + "4ffb759176d11d444b196f23b66307eb.png";